import request from '../utils/request';

export function loginUser(data: { username: string; password: string }) {
  return request
    .get('/customer/login', { params: data })
    .then((res) => res.data);
}
